import CardScoresPlus from './CardScoresPlus';
import './CardScoresPlus.scss';

export default CardScoresPlus;